import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Box, Fab, Tooltip, Zoom } from '@material-ui/core';
import { Flip } from '@material-ui/icons';
import { useTheme } from '@material-ui/core/styles';

import useStyles from './styled/SidebarStyles';
import { useMinWidth } from '../../hooks/useResize';
import { sizes } from '../../styles/variables';

export default () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { fixSidebar, pinSidebarIcon } = useSelector((state) => state.userInterface);
  const classes = useStyles();
  const isMinWidth = useMinWidth(sizes.mdMin);

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };

  const fixSidebarLabel = fixSidebar ? t('unpin.sidebar') : t('pin.sidebar');

  const handleSwitch = useCallback(() => {
    dispatch({ type: 'SET_VISIBILITY_FILTER', filter: { visibleSidebar: false, visibleWorkspaces: false, fixSidebar: !fixSidebar } });

    if (fixSidebar) {
      dispatch({ type: 'TOGGLE_PIN_SIDEBAR_ICON', pinSidebarIcon: { pinSidebarIcon: false } });
    }
  }, [fixSidebar]);

  if (isMinWidth) return '';

  return (
    <Box className={classes.fab} style={{ visibility: pinSidebarIcon ? 'visible' : 'hidden' }}>
      <Zoom
        in={pinSidebarIcon}
        timeout={transitionDuration}
        className={classes.zoom}
        unmountOnExit
      >
        <Tooltip aria-label="fix-sidebar-tooltip" title={fixSidebarLabel}>
          <Fab aria-label="fix-sidebar" color="primary" onClick={handleSwitch}>
            <Flip />
          </Fab>
        </Tooltip>
      </Zoom>
    </Box>
  );
};
